export const pixelGroups = {
  '101358775_469269': [
    { pixel: '25652549971004796', event: 'TEST40644' }
  ],
  '101227434_468575': [
    { pixel: '623358863398969', event: 'TEST66687' }
  ],
  '101358768_469271': [
    { pixel: '948034513944672', event: 'TEST12846' }
  ],
  '101358773_470853': [
    { pixel: '1347819929711666', event: 'TEST85857' }
  ],
  '101358776_469265': [
    { pixel: '1373443907584680', event: 'TEST12205' },
    { pixel: '1557957948881128', event: 'TEST62175' }
  ],
  '102353442_474602': [
    { pixel: '2631280347261069', event: 'TEST95039' }
  ],
  '102353443_474603': [
    { pixel: '510931511442994', event: 'TEST52062' }
  ],
  '102353444_474604': [
    { pixel: '2680022942205542', event: 'TEST75919' }
  ],
  '102353445_474605': [
    { pixel: '1374647784308149', event: 'TEST12205' }
  ],
  '102353446_474606': [
    { pixel: '1475756013486572', event: 'TEST47846' }
  ]

}
